<template>
	<transition name="fade" v-if="config.show">
		<div class="modal-box">
			<div class="modal modal p-0">
				<div class="modal-header clearfix">
					<h2 class="pull-left">
						회원통합
					</h2>
					<a class="close" @click="$emit('close')">&times;</a>
				</div>
				<div class="modal-body p-10 clearfix" style="min-height: 100px;background-color: #f8f8f8;">
					<table class="table2 table-condensed table-hover m-t-10 text-center">
						<tbody v-for="(user, idx) in userList" :key="`unify-user-${hash(user)}`">
							<tr :class="checkUser === user ? 'on': ''">
								<td>
									<input :id="`check-unify-leader-${idx}`" class="checkbox" type="checkbox" @click="checkUser = user" :checked="checkUser === user">
									<label :for="`check-unify-leader-${idx}`" class="v-mid">체크버튼</label>
									<span class="text-blue v-mid" v-show="checkUser === user">대표</span>
								</td>
								<td class="text-left">
									{{user.mberName}}
								</td>
								<td>
									{{user.mberId}}
								</td>
								<td>
									{{moment(user.regDate).format("YYYY-MM-DD")}}
								</td>
								<td class="text-left">{{user.joinPath}}</td>
								<td>
									<a class="del" @click="userList.splice(idx, 1);">제거</a>
								</td>
							</tr>
							<tr class="margin">
								<td colspan="6"></td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="modal-footer p-10" style="background-color: #f8f8f8;">
					<button class="btn bg-deepblue full-width text-white round" @click="unifyMembers">통합</button>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import Axios from 'axios';
import server from '../statics/server.js'

export default {
	name: "ModalUserUnify",
	default: function() {
		return {
			name: this.name,
			show: false,
			userList: []
		}
	},
	data: function() {
		const userList = JSON.parse(JSON.stringify(this.config.userList));

		return {
			userList,
			checkUser: userList[0]
		}
	},
	methods: {
		unifyMembers: function() {
			this.$emit("onConfirm", {
				message: "정말로 통합하시겠습니까?",
				yesCb: async () => {
					try {
						await Axios.patch(`${server.addr()}${server.api.MBER}/${this.checkUser.mberId}/unify`, this.userList.filter(user => user !== this.checkUser).map(el=>el.mberId));
						this.$emit("onDone", "회원이 통합되었습니다.");
						this.$emit("refresh");
						this.config.show = false;
					} catch(e) {
						// TODO: 서버쪽 오류랑 매핑시킬 것!
						this.$emit("onDone", "서버 오류");
					}
				}
			})
		}
	},
	props: {
		config: Object
	}
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}
</style>